// extracted by mini-css-extract-plugin
export default {"contactSection":"ContactPage_contactSection__fxBN1","contactForm":"ContactPage_contactForm__QrH8w","companyInfoSection":"ContactPage_companyInfoSection__I9Dje"};